import React from 'react';

import { Typography, styled } from '@gogame/components';
import { Filter, FilterActions } from '@gogame/filters';

const Color = styled('div')`
  width: 16px;
  height: 16px;
  background-color: ${(props) => props.color};
  margin-right: 8px;
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
`;

export const ColorOptionTemplate = ({ name, color }) => (
  <React.Fragment>
    <Color color={color} />
    <Typography noWrap={true}>{name}</Typography>
  </React.Fragment>
);

const LabelsFilter = (props) => (
  <Filter.MultiSelect
    title={'Labels'}
    placeholder={'All'}
    compareActions={[<FilterActions.Equalize />]}
    renderOption={ColorOptionTemplate}
    {...props}
  />
);

export default LabelsFilter;
